import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import moment from 'moment';
import s from './Gallery.module.css';

export default class Gallery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            photoIndex: 0,
            isOpen: false,
            photos: this.props.photos,
        };
        this.images = [];
    }

    render() {
        const { photoIndex, isOpen } = this.state;

        let nextSrc = this.images[(photoIndex + 1) % this.images.length]?.url;
        let prevSrc = this.images[(photoIndex + this.images.length - 1) % this.images.length]?.url;

        if (this.images.length === 1) {
            nextSrc = undefined;
            prevSrc = undefined;
        }

        this.state.photos.forEach((photo) => {
            const date = moment(photo.created_at).format('DD.MM.YYYY, HH:mm');
            const isPictureInArray = this.images.find((item) => item.url === photo.original_url);

            if (!isPictureInArray) {
                this.images.push({
                    url: photo.original_url,
                    id: photo.id,
                    photoDate: date,
                });
            }
        });

        return (
            <div className={s.overlay}>
                <div className={s.photosWrapper}>
                    {this.props.photos.map((photo) => (
                        <div
                            key={photo.id}
                            onClick={() =>
                                this.setState({
                                    isOpen: true,
                                    photoIndex: this.images.findIndex(
                                        (item) => item.id === photo.id
                                    ),
                                })
                            }
                        >
                            <img
                                width={30}
                                height={30}
                                src={photo.thumbnail_url}
                                alt={photo.original_name}
                                className={s.actionPhoto}
                            />
                        </div>
                    ))}
                </div>

                {isOpen && (
                    <Lightbox
                        reactModalStyle={{ overlay: { zIndex: 1300 } }}
                        mainSrc={this.images[photoIndex].url}
                        nextSrc={nextSrc}
                        prevSrc={prevSrc}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                        imagePadding={100}
                        imageCaption={this.images[photoIndex].photoDate}
                        wrapperClassName={s.gallery}
                        onMovePrevRequest={() => {
                            this.setState({
                                photoIndex:
                                    (photoIndex + this.images.length - 1) % this.images.length,
                            });
                        }}
                        onMoveNextRequest={() => {
                            this.setState({
                                photoIndex: (photoIndex + 1) % this.images.length,
                            });
                        }}
                    />
                )}
            </div>
        );
    }
}
